import { defineStore } from 'pinia';
export const useSocketStore = defineStore({
  id: 'socket_chat',
  state: () => ({
    connectionId: null,
    socketIdx: null,
    proxyRequestModel: null,
    proxyResponseModel: null,
    type: '',
    status: 'WAIT',
    finish: '',
    progress: 0,
    progressInterval: null,
    workList: [],
    collectList: [],
    uploadList: [],
    stockLinkList: [],
    stockLinkTotalCount: 0,
    stockLinkSuccessCount: 0,
    stockLinkFailCount: 0,
    soldOutLog: [],
    deleteResultList: [],
    deleteStatus: null,
    remainedDeleteMarket: [],
    marketProductList: [],
    workIdCallbacks: new Map() // workId별 콜백 저장
  }),
  actions: {
    setConnectionId(id) {
      this.connectionId = id;
    },
    getConnectionId() {
      return this.connectionId;
    },
    setSocketIdx(idx) {
      this.socketIdx = idx;
    },
    getSocketIdx() {
      return this.socketIdx;
    },
    setType(type) {
      this.type = type;
    },
    setStatus(status) {
      this.status = status;
    },
    setWorkList(list) {
      this.workList = list;
    },
    setCollectList(reset, payload) {
      if (reset) {
        this.collectList = [];
        return;
      }
      this.collectList.push(payload);
    },
    setUploadList(reset, payload) {
      if (reset) {
        this.uploadList = [];
        return;
      }
      this.uploadList.push(payload);
    },
    setMarketProductList(reset, payload) {
      if (reset) {
        this.marketProductList = [];
        return;
      }
      this.marketProductList.push(payload);
    },
    setStockLinkList(reset, payload) {
      if (reset) {
        this.stockLinkList = [];
        this.stockLinkTotalCount = 0;
        this.stockLinkSuccessCount = 0;
        this.stockLinkFailCount = 0;
        return;
      }
      this.stockLinkTotalCount++;
      if (payload.isSuccess) {
        this.stockLinkSuccessCount++;
      } else if (payload.isSuccess === false) {
        this.stockLinkFailCount++;
      }
      this.stockLinkList.push(payload);
    },
    clearStockLinkMessages() {
      this.stockLinkList = [];
    },
    setProgress(type) {
      this.progress = localStorage.getItem('workStatusTime') ?? this.progress;
      if (type === 'start') {
        this.progressInterval = setInterval(() => {
          this.progress++;
          localStorage.setItem('workStatusTime', this.progress);
        }, 1000);
        return;
      } else if (type === 'pause') {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      } else if (type === 'stop') {
        clearInterval(this.progressInterval);
        localStorage.removeItem('workStatusTime');
        this.progressInterval = null;
        this.progress = 0;
      }
      this.progressInterval = null;
    },
    setFinish(payload) {
      this.finish = payload;
    },
    clearDeleteResult() {
      this.deleteResultList = [];
    },
    setDeleteResult(log) {
      this.deleteResultList.push(log);
      this.deleteResultList.push('');
      this.deleteResultList = this.deleteResultList.filter(result => result !== '');
    },
    setSoldOutLog(log) {
      this.soldOutLog.push(log);
    },
    clearSoldOutLog() {
      this.soldOutLog = [];
    },
    setRemainedDeleteMarket(list) {
      this.remainedDeleteMarket = list;
    },
    setDeleteStatus(socketData) {
      this.deleteStatus = socketData;

      if (socketData === null) {
        return;
      }

      const { marketInfo } = socketData;
      // market은 영문/한글 불일치라 계정 식별 필드로만 매칭, 타입/null 차이는 String(v ?? '')로 흡수
      this.remainedDeleteMarket = this.remainedDeleteMarket.filter(
        market =>
          String(market.marketAccount ?? '') !== String(marketInfo.marketAccount ?? '') ||
          String(market.marketIdx ?? '') !== String(marketInfo.marketIdx ?? '') ||
          String(market.marketSubIdx ?? '') !== String(marketInfo.marketSubIdx ?? '')
      );
    }
  }
});

export const useSocketStoreStock = defineStore({
  id: 'socket_chat',
  state: () => ({
    connectionId: null,
    proxyRequestModel: null,
    proxyResponseModel: null,
    type: '',
    status: 'WAIT',
    finish: '',
    progress: 0,
    progressInterval: null,
    workList: [],
    collectList: [],
    uploadList: [],
    stockLinkList: [],
    stockLinkTotalCount: 0,
    stockLinkSuccessCount: 0,
    stockLinkFailCount: 0,
    soldOutLog: [],
    deleteResultList: [],
    deleteStatus: null,
    remainedDeleteMarket: []
  }),
  actions: {
    setConnectionId(id) {
      this.connectionId = id;
    },
    getConnectionId() {
      return this.connectionId;
    },
    setType(type) {
      this.type = type;
    },
    setStatus(status) {
      this.status = status;
    },
    setWorkList(list) {
      this.workList = list;
    },
    setCollectList(reset, payload) {
      if (reset) {
        this.collectList = [];
        return;
      }
      this.collectList.push(payload);
    },
    setUploadList(reset, payload) {
      if (reset) {
        this.uploadList = [];
        return;
      }
      this.uploadList.push(payload);
    },
    setStockLinkList(reset, payload) {
      if (reset) {
        this.stockLinkList = [];
        this.stockLinkTotalCount = 0;
        this.stockLinkSuccessCount = 0;
        this.stockLinkFailCount = 0;
        return;
      }
      this.stockLinkTotalCount++;
      if (payload.isSuccess) {
        this.stockLinkSuccessCount++;
      } else if (payload.isSuccess === false) {
        this.stockLinkFailCount++;
      }
      this.stockLinkList.push(payload);
    },
    clearStockLinkMessages() {
      this.stockLinkList = [];
    },
    setProgress(type) {
      this.progress = localStorage.getItem('workStatusTime') ?? this.progress;
      if (type === 'start') {
        this.progressInterval = setInterval(() => {
          this.progress++;
          localStorage.setItem('workStatusTime', this.progress);
        }, 1000);
        return;
      } else if (type === 'pause') {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      } else if (type === 'stop') {
        clearInterval(this.progressInterval);
        localStorage.removeItem('workStatusTime');
        this.progressInterval = null;
        this.progress = 0;
      }
      this.progressInterval = null;
    },
    setFinish(payload) {
      this.finish = payload;
    },
    clearDeleteResult() {
      this.deleteResultList = [];
    },
    setDeleteResult(log) {
      this.deleteResultList.push(log);
      this.deleteResultList.push('');
      this.deleteResultList = this.deleteResultList.filter(result => result !== '');
    },
    setSoldOutLog(log) {
      this.soldOutLog.push(log);
    },
    clearSoldOutLog() {
      this.soldOutLog = [];
    },
    setRemainedDeleteMarket(list) {
      this.remainedDeleteMarket = list;
    },
    setDeleteStatus(socketData) {
      this.deleteStatus = socketData;

      if (socketData === null) {
        return;
      }

      const { marketInfo } = socketData;
      // market은 영문/한글 불일치라 계정 식별 필드로만 매칭, 타입/null 차이는 String(v ?? '')로 흡수
      this.remainedDeleteMarket = this.remainedDeleteMarket.filter(
        market =>
          String(market.marketAccount ?? '') !== String(marketInfo.marketAccount ?? '') ||
          String(market.marketIdx ?? '') !== String(marketInfo.marketIdx ?? '') ||
          String(market.marketSubIdx ?? '') !== String(marketInfo.marketSubIdx ?? '')
      );
    }
  }
});
